import { ContactsDTO } from "../domain/models/dto/ContactsDTO";
import { IContacts } from "../domain/models/Contacts";
import { ContactsService } from "../domain/services/ContactsService";
import { ContactsMapper } from "../mappers/ContactsMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";

export class ContactsServiceImpl extends BaseServiceImpl implements ContactsService {
    static _instance: ContactsService;
    private readonly contactsEndpoint = "/api/v1/contacts";

    private constructor() {
        super();
    }

    static getInstance(): ContactsService {
        if (!ContactsServiceImpl._instance) {
            ContactsServiceImpl._instance = new ContactsServiceImpl();
        }
        return ContactsServiceImpl._instance;
    }

    async getContacts(): Promise<IContacts | null> {
        try {
            const dto = await this.get<ContactsDTO>(this.contactsEndpoint);
            if (!dto) return null;
            return new ContactsMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in ContactsServiceImpl.getContacts");
            console.log(err);
            return null;
        }
    }
}

export function contactsServiceFactory(): ContactsService {
    return ContactsServiceImpl.getInstance();
}

